// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AssignmentIcon from "@mui/icons-material/Assignment";
import {deleteArrayItemByKeyValue, setArrayKey} from "../../utils/misc";


class CertificateCreateModal extends CommonActionModal {
    async componentDidMount() {
        let formFields = await this.retrieveFields();
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Добавить',
            buttonColor: 'success',
            modalLabel: 'Создание акта',
            modalIcon: AssignmentIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
            ready: true,
        })
    }

    async retrieveFields() {
        const url = `certificate/create_form/`;
        const api = new BaseApi();
        let fields = [
            'revenue',
            'currency',
            'date',
            'phase',
        ]
        if (!this.props.opportunity){
            fields.push('opportunity')
        }
        let response = await api.get(
            url,
            {
                fields: JSON.stringify(fields)
            }
        );
        let formFields = response.data
        if (this.props.phases && this.props.phases?.length){
            setArrayKey(
                formFields,
                'name',
                'phase',
                'options',
                this.props.phases.map((phase) => (
                    {
                        value: phase.id,
                        label: phase.title,
                    }
                ))
            )
        }
        else {
            formFields = deleteArrayItemByKeyValue(
                formFields,
                'name',
                'phase'
            );
        }
        return (formFields)
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        if (this.props.opportunity){
            formDataObj.opportunity = this.props.opportunity.id;
        }
        const url = `certificate/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            if (this.props.callBack){
                await this.props.callBack()
            }
            this.setModalOpenFalse();
        }
        return response
    }
}

export default CertificateCreateModal